import Box from '@mui/material/Box';
import React from 'react';
import { Card, CardActionArea, CardContent, CardMedia } from "@mui/material";
import Typography from "@mui/material/Typography";
import tableauElec from '../images/TableauElec.jpeg';
import chargeCar from '../images/chargeCar.jpg';
import energieRen from '../images/EnergieRen.jpg';
import domotique from '../images/domotique.jpg';
import security from '../images/security.jpg';
import { Link } from "react-router-dom";
import Grid2 from '@mui/material/Unstable_Grid2';
import {motion} from "framer-motion";

const ContentSection = () => {
    const fadeInUp = {
        initial: { opacity: 0, y: 30 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.8, ease: "easeOut" },
    };
    return (
        <Box sx={{ padding: { xs: '20px ', md: '70px 0' }, backgroundColor: '#f0f4fa' }}>
            <Box sx={{ maxWidth: 'lg', margin: '0 auto' }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingBottom: { xs: '20px', md: '50px' },
                    textAlign: { xs: 'center', md: 'center' } // Centrer le texte sur mobile
                }}>
                    <Typography variant={"h4"} sx={{
                        textTransform: 'uppercase',
                        fontFamily: 'unset',
                        fontWeight: 'bold',
                        color: '#3f72b5',
                        fontSize: { xs: '1.5rem', md: '2.5rem' }, // Taille réduite sur mobile
                    }}>
                        Choisissez CP pour un avenir où technologie et écologie s'harmonisent !
                    </Typography>
                </Box>

                <Grid2 container spacing={5} justifyContent="center" component={motion.div} {...fadeInUp} transition={{ delay: 0.5 }}>
                    {[
                        { title: "Électricité générale", image: tableauElec, link: "/electricite-generale" },
                        { title: "Mobilité électrique", image: chargeCar, link: "/mobilite-electrique" },
                        { title: "Énergie renouvelable", image: energieRen, link: "/energie-renouvelable" },
                        { title: "Domotique", image: domotique, link: "/domotique" },
                        { title: "Sécurité", image: security, link: "/sécurité" }
                    ].map((card, index) => (
                        <Grid2 xs={12} sm={6} md={4} key={index}>
                            <Card

                                sx={{
                                    height: { xs: 250, md: 350 }, // Hauteur réduite pour mobile
                                    borderRadius: 9,
                                    boxShadow: 3,
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                        boxShadow: 6,
                                    },
                                    position: 'relative',

                                }}
                            >
                                <CardActionArea component={Link} to={card.link} sx={{ height: '100%' }}>
                                    <CardMedia
                                        component="img"
                                        image={card.image}
                                        alt={card.title}
                                        sx={{
                                            height: '100%',
                                            width: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            width: {xs: '100%', md: '60%'}, // Prend toute la largeur sur mobile
                                            backgroundColor: '#6e88a6',
                                            color: '#fff',
                                            textAlign: 'center',
                                            padding: '10px 0',
                                            borderBottomLeftRadius: { xs: 9, md: 0 }, // Arrondi sur mobile
                                            borderBottomRightRadius: 9,
                                        }}
                                    >
                                        <Typography variant="h6" sx={{ fontFamily: 'inherit' }} component="div">
                                            {card.title}
                                        </Typography>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        </Grid2>
                    ))}
                </Grid2>
            </Box>
        </Box>
    );
};

export default ContentSection;
